<template>
  <div
    v-if="heading || ctalink"
    :class="`refapp-video__content refapp-video__content--${alignment} font-${display.contentFont}`"
  >
    <div>
      <slot>
        <component
          :is="`h${headingLevel}`"
          v-if="heading"
          :class="`refapp-video__content-heading font-${display.headingFont}`"
        >
          {{ heading }}
        </component>

        <p v-if="text" class="refapp-video__content-text">
          {{ text }}
        </p>
      </slot>
    </div>

    <a
      v-if="ctalink && ctatext"
      class="refapp-video__content-cta"
      :href="ctalink"
      target="_blank"
      data-refapp-tagging-target="cta"
    >
      {{ ctatext }}
    </a>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
export default {
  name: 'refapp-video-content',
  inject: ['heading', 'headingLevel', 'text', 'ctalink', 'ctatext', 'alignment', 'display'],
};
</script>
